import intl from 'react-intl-universal';
import { OccType } from '@/config/constant';

// 账务科目Code（OTA房费预付）
const OTA_SUBJECT_CODE = 'D01010002';
// 账务科目Code（房费预付）
const DEPOSIT_SUBJECT_CODE = 'D01010001';
// 账务科目Code（查房商品消费）
const CHAFANG_GOODS_SUBJECT_CODE = 'DJ10000001';
// 账务科目Code（前台商品消费）
const QIANTAI_GOODS_SUBJECT_CODE = 'DJ10000002';

const GOODS_SUBJECT_CODE_LIST = ['DJ10000001', 'DJ10000002'];

// 支付方式
const PAY_TYPE_MAP = {
  1: intl.get('bill_config_cash'),
  2: intl.get('bill_config_recharge_balance'),
  3: intl.get('bill_config_scan_pay'),
  15: intl.get('bill_config_choose_live_balance'),
};

// 美团直连
const MT_ZL = 'MT_ZL';

// 美团直连账务科目
const MT_SUBJECTS = [
  {
    value: 'D04040001',
    label: intl.get('bill_config_meituan_book_penalty'),
  },
];

// 抖音直连
const DY_ZL = 'DY_ZL';

// 抖音直连账务科目
const DY_SUBJECTS = [
  {
    value: 'D04060001',
    label: intl.get('bill_config_tiktok_book_penalty'),
  },
];

// 携程直连
const XC_ZL = 'XC_ZL';

// 携程直连账务科目
const XC_SUBJECTS = [
  {
    value: 'D04050001',
    label: intl.get('bill_config_trip_book_penalty'),
  },
];

// 加收房费账务科目
const ROOM_RATE_PLUS_SUBJECTS = [
  {
    value: 'D03050001',
    label: intl.get('bill_config_add_whole_room_fee'),
    extra: intl.get('bill_config_day_room_rate'),
    subjectOccType: OccType.DayUse,
  },
  // {
  //   value: 'D03060001',
  //   label: '加收半天房费',
  //   extra: '该项入账后，统计时会算 0.5 间的日租房入住率，全额冲调后可撤销',
  // },
  {
    value: 'D03070001',
    label: intl.get('bill_config_add_hour_room_rate'),
    extra: intl.get('bill_config_hour_room_rate'),
    subjectOccType: OccType.TimeRENT,
  },
];

// 支付渠道
// const PAY_TYPE_CODE_MAP = {
//   WX: '微信',
//   ZFB: '支付宝',
//   FKD: '付款单',
//   CASH: '现金',
//   MEMBER_CARD: '储值余额',
//   BANK_CARD: '线下银行卡',
//   CRS: '中央预订',
//   XUANZHU: '选住余额',
//   UNION_PAY: '银联',
//   FZ: '飞猪',
//   MT: '美团',
//   XC: '携程',
//   QNE: '去哪儿',
//   DY: '抖音',
//   MT_ZL: '美团直连',
//   XC_ZL: '携程直连',
//   DY_ZL: '抖音直连',
// };

// 订单状态map
const ORDER_STATE_MAP = {
  0: intl.get('bill_config_temp_storage'),
  1: intl.get('bill_config_book_order'),
  2: intl.get('bill_config_live_order'),
  3: intl.get('bill_config_book_cancel_order'),
  4: intl.get('bill_config_refound_order'),
  5: intl.get('bill_config_connected_room_order'),
};

// 订单房间状态map
const ORDER_ROOM_STATE_MAP = {
  1: intl.get('bill_config_booking'),
  2: intl.get('bill_config_book_cancel'),
  3: intl.get('bill_config_living'),
  4: intl.get('bill_config_refounded'),
};

// 订单结账状态map
const ORDER_BILL_STATE_MAP = {
  0: intl.get('bill_config_uncharge'),
  1: intl.get('bill_config_charged'),
};

// 订单结账步骤map
const ORDER_SETTLE_STEP_MAP = {
  0: intl.get('bill_config_not_yet_charge'),
  1: intl.get('bill_config_disposed_account'),
  2: intl.get('bill_config_checked_room'),
  3: intl.get('bill_config_has_settled'),
};

// 账单入账类型map
const BILL_TYPE_MAP = {
  0: intl.get('bill_config_consume'),
  1: intl.get('bill_config_pay'),
  2: intl.get('bill_config_chong_tiao'),
  3: intl.get('bill_config_preferential'),
  4: intl.get('bill_config_refound'),
};

// 账单结账状态map
const BILL_STATE_MAP = {
  0: intl.get('bill_config_uncharge'),
  1: intl.get('bill_config_charged'),
};

// 账单入账类型筛选
const BILL_FILTER_TYPES = [
  {
    value: -1,
    label: intl.get('bill_config_all'),
  },
  {
    value: 1,
    label: intl.get('bill_config_pay'),
  },
  {
    value: 0,
    label: intl.get('bill_config_consume'),
  },
];

// 账单结账状态筛选
const BILL_FILTER_STATES = [
  {
    value: -1,
    label: intl.get('bill_config_all'),
  },
  {
    value: 0,
    label: intl.get('bill_config_uncharge'),
  },
  {
    value: 1,
    label: intl.get('bill_config_charged'),
  },
];

// 账单转账房间状态map
const BILL_TRANSFER_ROOM_STATE_MAP = {
  0: intl.get('bill_config_empty'), // 空闲
  1: intl.get('bill_config_book'), // 预订
  2: intl.get('bill_config_live'), // 在住
  3: intl.get('bill_config_stop'), // 停用
};

// 房间入住类型
const ROOM_OCC_TYPES = {
  DAY_USE: intl.get('bill_config_day_room'),
  TIME_RENT: intl.get('bill_config_hur_room'),
};

// 房间入住时长
const ROOM_OCC_DURATION = {
  DAY_USE: intl.get('bill_config_night'),
  TIME_RENT: intl.get('bill_config_hour'),
};

// 查房类型map
const CHECK_ROOM_TYPE_MAP = {
  1: intl.get('bill_config_live_check_room'),
  2: intl.get('bill_config_exchage_room_check'),
  3: intl.get('bill_config_checkout_room_check'),
};

// 查房结果map
const CHECK_STATUS_MAP = {
  1: intl.get('bill_config_wait_room_check'),
  2: intl.get('bill_config_has_room_check'),
};

// 电脑状态map
const COMPUTER_STATUS_MAP = {
  1: intl.get('bill_config_normal'),
  2: intl.get('bill_config_abnormal'),
  3: intl.get('bill_config_unknown'),
};

export {
  OTA_SUBJECT_CODE,
  DEPOSIT_SUBJECT_CODE,
  CHAFANG_GOODS_SUBJECT_CODE,
  QIANTAI_GOODS_SUBJECT_CODE,
  GOODS_SUBJECT_CODE_LIST,
  MT_ZL,
  ROOM_RATE_PLUS_SUBJECTS,
  XC_ZL,
  DY_ZL,
  MT_SUBJECTS,
  XC_SUBJECTS,
  DY_SUBJECTS,
  PAY_TYPE_MAP,
  // PAY_TYPE_CODE_MAP,
  ORDER_STATE_MAP,
  ORDER_ROOM_STATE_MAP,
  ORDER_BILL_STATE_MAP,
  ORDER_SETTLE_STEP_MAP,
  BILL_TYPE_MAP,
  BILL_STATE_MAP,
  BILL_FILTER_TYPES,
  BILL_FILTER_STATES,
  BILL_TRANSFER_ROOM_STATE_MAP,
  ROOM_OCC_TYPES,
  ROOM_OCC_DURATION,
  CHECK_ROOM_TYPE_MAP,
  CHECK_STATUS_MAP,
  COMPUTER_STATUS_MAP,
};
